<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-content-row-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Content Row
            </h4>
          </div>

          <div v-if="!loading" class="modal-body">
            <TextFormGroup
                v-model="data.headline"
                name="headline"
                label="Headline"
                :error="getError('headline')"
            />

            <TextFormGroup
                v-model="data.link_text"
                name="link_text"
                label="Link Text"
                :error="getError('link_text')"
            />

            <TextFormGroup
                v-model="data.link_path"
                name="link_path"
                label="Link Path"
                :error="getError('link_path')"
            />

            <SelectFormGroup
                v-model="data.content_color_id"
                name="content_color_id"
                label="Color"
                :error="getError('content_color_id')"
                :nullable="true"
                :options="contentColorOptions"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {SelectFormGroup, TextFormGroup},

  mixins: [Errors],

  props: {
    contentRow: {
      required: true
    },

    portal: {
      required: true
    },
  },

  data() {
    return {
      data: {},

      contentColors: null,

      loading: true
    }
  },

  watch: {
    contentRow() {
      this.data = {...this.contentRow.attributes}
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  computed: {
    contentColorOptions() {
      return this.contentColors.map(contentColor => ({value: contentColor.id, label: contentColor.attributes.name}))
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    load() {
      http.get('/api/v2/content-colors', {'filter[portal_id]': this.portal.id}).then(response => {
        this.contentColors = response.data.data

        this.loading = false
      })
    },

    submit() {
      http.put(this.contentRow.links.self, this.data)
          .then(response => {
            notify.success('The row was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {...this.contentRow.attributes}
    }
  }
}
</script>
